export default __webpack_public_path__ + "static/media/header-logo.0349b18c.svg";